var alignment_rtlignore_default = {
  "alignLeft": "yHGs6",
  "textWrapNowrap": "zuiJA",
  "alignRight": "e1G4y",
  "alignCenter": "KCUmc",
  "sizeFullWidth": "LmfEO",
  "renderedInTable": "D8w-U",
  "sizeOriginal": "WSiq0",
  "sizeContent": "KsXLS",
  "sizeSmall": "g0ZRo",
  "sizeSmallCenter": "_5tJWZ",
  "flex": "wz2Yg",
  "LEFT": "hn7M6",
  "CENTER": "c4bHW",
  "RIGHT": "_2z6Gs",
  "AUTO": "_7F2iW",
  "JUSTIFY": "d2wYW"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
